document.addEventListener("DOMContentLoaded", function () {
  console.log("🦄🦄 DOM fully loaded and parsed");
  const observer = new MutationObserver(() => {
    const input = document.querySelector(
      "input.boost-sd__search-widget-init-input"
    );

    if (input && document.activeElement === input) {
      console.log("Input found and focused, clicking it now.");
      input.click();
      const length = input.value.length;
      input.setSelectionRange(length, length);
      observer.disconnect(); // Deja de observar después de hacer clic
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
